<template>
  <ol class="fg-progress" :aria-label="t('steps.aria')">
    <li
      v-for="(step, i) in steps"
      :key="step.key"
      class="fg-progress__item"
      :class="{ 'is-current': step.key === current, 'is-done': i < currentIndex }"
      :aria-current="step.key === current ? 'step' : undefined"
    >
      <span class="fg-progress__dot">
        <Icon v-if="i < currentIndex" name="check" :size="11" />
        <template v-else>{{ i + 1 }}</template>
      </span>
      <span class="fg-progress__label">{{ step.label }}</span>
    </li>
  </ol>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from '../../store'
import { useI18n } from '../../i18n'
import { hasMealOptions } from '../../utils/meals'
import Icon from '../Icon.vue'

/** Fil de progression du funnel, affiché dans le header de chaque étape
 *  overlay. L'étape Options n'apparaît que si le sailing aller propose des
 *  options (même condition que la navigation continueNext/back). */
const props = defineProps<{ current: 'trip' | 'options' | 'details' | 'summary' }>()

const store = useStore()
const { t } = useI18n()

const steps = computed(() => {
  const list: Array<{ key: string; label: string }> = [
    { key: 'trip', label: t('steps.trip') },
  ]
  if (hasMealOptions(store)) {
    list.push({ key: 'options', label: t('steps.options') })
  }
  list.push({ key: 'details', label: t('steps.details') })
  list.push({ key: 'summary', label: t('steps.summary') })
  return list
})

const currentIndex = computed(() => steps.value.findIndex((s) => s.key === props.current))
</script>
